import { AuthenticationService } from './../authentication/authentication.service';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ClientConstants, LocalStorageService, LocalStorageKeys, WorkerService } from '@formbird/services';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
    private location = inject(Location);
    private authenticationService = inject(AuthenticationService);
    private localStorageService = inject(LocalStorageService);
    private workerService = inject(WorkerService);


    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const navExtras = { skipLocationChange: true, replaceUrl: false };
        return next.handle(req).pipe(
            tap(event => {
                // user is authenticated
            },
            error => {
                if (error.status === ClientConstants.HTTP_STATUS_LOGIN_REJECTED) {
                    this.workerService.terminateAllWorkers();

                    const authRoutes = [
                        '/login', '/auth/login',
                        '/forgotpass', '/auth/forgotpass',
                        '/signup', '/auth/signup',
                        '/resetpass', '/auth/resetpass',
                        '/activateAccount', '/auth/activateAccount'
                    ];

                    const checkPublicUser = this.localStorageService.getItem(LocalStorageKeys.CHECK_PUBLIC_USER);
                    if (!authRoutes.find(route => this.location.path().startsWith(route)) && !checkPublicUser) {
                        this.authenticationService.showLogin();
                    }
            }
        }));
    }
}
